import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BatchStatus } from 'src/app/models/batch';
import { BatchScore } from 'src/app/helpers/batch-score.helper';

@Component({
  selector: 'app-batch-score',
  templateUrl: './batch-score.component.html',
  styleUrls: ['./batch-score.component.scss']
})
export class BatchSCoreComponent implements OnInit {
  @Input() score: BatchScore = {
    ok: 0,
    warning: 0,
    error: 0,
    total: 1
  }
  @Input() status: BatchStatus = BatchStatus.OPENED;

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
  }

  globalScore() {
    if (this.score.total === 0) {
      return {
        value: `N/A`,
        color: 'light'
      }
    } else {
      const score = this.score.score ? Math.round(this.score.score) : Math.round(100 * (this.score.ok + this.score.warning * 0.5) / this.score.total);
      return {
        value: `${score}%`,
        color: score < 50 ? 'red' : (score < 75 ? 'orange' : 'green')
      }
    }

  }

  tooltip(key: string) {
    return `${this.score[key as keyof BatchScore]} ${this.translate.instant('BATCH.DOCUMENT_' + key.toUpperCase()).toLowerCase()}`
  }
}
